/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { largerDependencies } from './dependenciesLarger.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createMaxTransform } from '../../factoriesAny.js';
export var maxTransformDependencies = {
  largerDependencies: largerDependencies,
  typedDependencies: typedDependencies,
  createMaxTransform: createMaxTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesMaxTransform.generated.js
// module id = 1451
// module chunks = 0